module.exports = __webpack_public_path__ + "img/ridehail.f2d63e54.png";